import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { colors, Text } from 'ic-snacks'

const HourHeaderContainer = styled.div<{ isWeeklyView: boolean }>(({ isWeeklyView }) => ({
  height: '100%',
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  background: colors.WHITE,
  textAlign: 'center',
  borderRight: isWeeklyView ? '2px solid transparent' : `1px solid ${colors.GRAY_93}`,
}))

interface Props {
  children: React.ReactNode
  isWeeklyView?: boolean
}

const HourHeader: FunctionComponent<Props> = ({ isWeeklyView, children }) => (
  <HourHeaderContainer data-testid="shopper-shifts-hour-container" isWeeklyView={isWeeklyView}>
    <Text elementType="span" variant="T.12" fontWeight="semiBold" style={{ color: colors.GRAY_46 }}>
      {children}
    </Text>
  </HourHeaderContainer>
)

export default HourHeader
